import api from './api';

const userService = {
  // Get all users (Admin only) with pagination support
  getAllUsers: async (page = 1, pageSize = 5) => {
    const response = await api.get(`/auth/admin/users/?page=${page}&page_size=${pageSize}`);
    return response.data;
  },

  // Get user details by ID (Admin only)
  getUserDetails: async (userId) => {
    const response = await api.get(`/auth/admin/users/${userId}/`);
    return response.data;
  },

  // Toggle user status (activate/deactivate)
  toggleUserStatus: async (userId) => {
    const response = await api.patch(`/auth/admin/users/${userId}/toggle-status/`);
    return response.data;
  },

  // Change user role
  changeUserRole: async (userId, role) => {
    const response = await api.patch(`/auth/admin/users/${userId}/change-role/`, { role });
    return response.data;
  },

  // Delete user
  deleteUser: async (userId) => {
    const response = await api.delete(`/auth/admin/users/${userId}/delete/`);
    return response.data;
  },

  // Assign course to user
  assignCourse: async (userId, courseId) => {
    const response = await api.post(`/auth/admin/users/${userId}/assign-course/`, { course_id: courseId });
    return response.data;
  },

  // Get available courses for a user (courses not already assigned)
  getAvailableCoursesForUser: async (userId) => {
    const response = await api.get(`/auth/admin/users/${userId}/available-courses/`);
    return response.data;
  },

  // Remove course from user
  removeCourse: async (userId, courseId) => {
    const response = await api.delete(`/auth/admin/users/${userId}/remove-course/${courseId}/`);
    return response.data;
  },
};

export default userService;
